import { render } from "./Badges.vue?vue&type=template&id=731504a8"
import script from "./Badges.vue?vue&type=script&lang=js"
export * from "./Badges.vue?vue&type=script&lang=js"

import "./Badges.vue?vue&type=style&index=0&id=731504a8&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_cecra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__